import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDdStepActive = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0 0.4444) scale(0.8889)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M26.2016 12.8C26.2016 19.8692 20.4708 25.6 13.4016 25.6C6.33232 25.6 0.601562 19.8692 0.601562 12.8C0.601562 5.73076 6.33232 0 13.4016 0C20.4708 0 26.2016 5.73076 26.2016 12.8ZM3.94239 12.8C3.94239 18.0242 8.17741 22.2592 13.4016 22.2592C18.6257 22.2592 22.8607 18.0242 22.8607 12.8C22.8607 7.57584 18.6257 3.34083 13.4016 3.34083C8.17741 3.34083 3.94239 7.57584 3.94239 12.8Z",
			fill: "currentColor",
			fillOpacity: .15
		}), /* @__PURE__ */ _jsx("path", {
			d: "M11.8517 1.77885C11.7233 0.865297 12.3612 0.00903058 13.2837 0.000540175C14.7262 -0.0127359 16.1647 0.217901 17.5374 0.686591C19.4388 1.33576 21.1606 2.42338 22.5636 3.86146C23.9666 5.29954 25.0114 7.04769 25.6134 8.96447C26.048 10.3484 26.2431 11.7921 26.1942 13.2338C26.1629 14.1558 25.2912 14.7724 24.3811 14.6215C23.471 14.4705 22.8713 13.6071 22.86 12.6846C22.8488 11.7649 22.7035 10.8488 22.4261 9.96555C21.9812 8.54905 21.2091 7.25718 20.1723 6.19444C19.1355 5.1317 17.863 4.32795 16.458 3.84822C15.5819 3.5491 14.6696 3.38119 13.7504 3.34726C12.8285 3.31324 11.9802 2.69241 11.8517 1.77885Z",
			fill: "currentColor"
		})]
	})]
});
const ForwardRef = forwardRef(SvgDdStepActive);
export default ForwardRef;
